module.exports = __webpack_public_path__ + "img/jshr_number.519fe9ad.png";